/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Debt_TitleInputs */

const en_case_section_debt_title = /** @type {(inputs: Case_Section_Debt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debts`)
};

const pt_br2_case_section_debt_title = /** @type {(inputs: Case_Section_Debt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débitos`)
};

/**
* | output |
* | --- |
* | "Debts" |
*
* @param {Case_Section_Debt_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_debt_title = /** @type {((inputs?: Case_Section_Debt_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Debt_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_debt_title(inputs)
	return pt_br2_case_section_debt_title(inputs)
});